import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query'
import {api} from '@/lib/api'
import type {components} from '@/lib/api-schema'

export type IndicadorTablero = components['schemas']['TableroRead']
export type FichaTablero = components['schemas']['FichaTableroRead']
export type IndicadorMedicion = components['schemas']['IndicadorMedicionRead']
export type MedicionCreate = components['schemas']['MedicionCreate']

export function useIndicadores(businessId: string | undefined) {
  return useQuery({
    queryKey: ['indicadores', businessId],
    queryFn: async () => (await api.get<IndicadorTablero>(`/businesses/${businessId}/sgsst/indicadores`)).data,
    enabled: !!businessId,
  })
}

export function useConfirmarMedicion(businessId: string, codigo: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (body: MedicionCreate) =>
      (await api.post<IndicadorMedicion>(`/businesses/${businessId}/sgsst/indicadores/${codigo}/mediciones`, body))
        .data,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['indicadores', businessId]})
    },
  })
}
